import React from 'react';
import PropTypes from 'prop-types';

import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../utils/behaviorSettings';
import withCookieConsentPopupFeed from './withCookieConsentPopupFeed';
import { FormattedHtmlWithScriptTag } from '../../../01_atoms/FormattedText';

import styles from './index.module.scss';

const ContentRawWithCookieConsent = withCookieConsentPopupFeed(({ html }) => (
  <FormattedHtmlWithScriptTag text={html} />
));

const BBRawHtml = ({ behaviorSettings = null, uuid = null, heading = '', ...props }) => (
  <div
    className={`bb bb-raw-html ${styles['bb-raw-html']} ${generateClassNameByBehaviorSettings(
      behaviorSettings,
    )}`}
    id={uuid}
  >
    <div className="container">
      {heading && <h2>{heading}</h2>}
      <ContentRawWithCookieConsent {...props} />
    </div>
  </div>
);

BBRawHtml.propTypes = {
  heading: PropTypes.string,
  html: PropTypes.string.isRequired,
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

export default BBRawHtml;
